import { UpdatesHistory } from '@strata/react-page-templates';

import { useGetHomeScreenMessagesQuery } from 'store/api/announcementApi';

export const UpdatesHistoryScreen = () => {
    const { data: messages } = useGetHomeScreenMessagesQuery();

    return <UpdatesHistory messages={messages} />;
};
